import $ from 'jquery';

(function () {
  $('.EmailMarketing, .OnlineAdvertising').attr('tabindex', '0');

  $(document).ready(() => {
    $(window).on('keydown', (event) => {
      // Is Email Marketing? by keyboard
      if (event.keyCode === 13 && $(event.target).hasClass('EmailMarketing')) {
        $(event.target).find('input[type="checkbox"]').click();
      }
      // Is Online Advertising? by keyboard
      if (event.keyCode === 13 && $(event.target).hasClass('OnlineAdvertising')) {
        $(event.target).find('input[type="checkbox"]').click();
      }
    });
  });
}());
